// Global constants
export const SHOW_PROGRESS = "progressComponent/SHOW_PROGRESS";
export const HIDE_PROGRESS = "progressComponent/HIDE_PROGRESS";

// Local constants
export const INDETERMINATE_PROGRESS_SHOW = "INDETERMINATE_PROGRESS_SHOW";
export const INDETERMINATE_PROGRESS_HIDE = "INDETERMINATE_PROGRESS_HIDE";
